
<ul class="nav navbar-nav">
    <li><a href="/">Home</a></li>
    <li><a routerLink="/epk">EPK</a></li>
    <li><a href="https://www.facebook.com/angelcrypt/events" target="_blank">Tour</a></li>
    <li><a href="https://angelcrypt.bandcamp.com/merch" target="_blank">Merch</a></li>
    <li><a routerLink="/contact">Contact</a></li>
</ul>
